// Pattern regex to validate string source: http://regexlib.com/REDetails.aspx?regexp_id=22
export const PatternValidationRegex = {
  ADDRESS_REGEX: /^['a-zA-ZÀ-ÿ-_\s0-9',.]+$/,
  ALPHANUMERIC_REGEX: /^[a-zA-Z0-9]*$/,
  API_CLIENT_ID: /^api_([a-z0-9]){32}$/,
  API_KEY: /^key_([a-z0-9]){32}$/,
  APPLICATION_ID_LEGACY: /^(T|C){1,2}Q[0123456789ABCDEFGH]{7,8}$/,
  APPLICATION_ID: /^(B|H|C)[0-9]{2}-[0-9A-Z]{8}$/,
  CAR_ID: /^car_(\d|[a-z]){32}$/,
  CAR_MODEL: /^['a-zA-ZÀ-ÿ-_\s0-9',.\(\)/&+]{2,}$/,
  // Ref: https://rgxdb.com/r/61PVCR9B (Match group have been removed to support older browsers)
  // VIN decoded: <wmi>{3} <vds>{5} <check>{1} <year>{1} <plant>{1} <seq>{6}
  // Ref for rules of regex: http://assets.ibc.ca/Documents/Brochures/Understanding-Vehicle-Identification-Numbers.pdf
  CAR_VIN: /^([A-HJ-NPR-Z\d]{3})([A-HJ-NPR-Z\d]{5})([\dX])([A-HJ-NPR-TV-Y1-9])([A-HJ-NPR-Z\d])([A-HJ-NPR-Z\d]{6})$/,
  CARRIER_QUOTE_ID: /^carrierquo_([a-z0-9]){32}$/,
  CLOSE: {
    TASK_ID: /^noti_([a-zA-Z0-9]{43})$/,
  },
  COMMON_CHARACTERS_REGEX: /^['a-zA-ZÀ-ÿ-_\s0-9',.\(\)/&]{2,1024}$/,
  DRIVER_ID: /^dri_(\d|[a-z]){32}$/,
  DRIVER_LICENCE_NUMBER: {
    ON: /^[a-zA-Z]\d{14}$/,
    QC: /^[a-zA-Z]\d{12}$/,
    INTERNATIONAL: /^\d{6,10}$/,
  },
  EMAIL_PATTERN: /^(([\.]?)[a-zA-Z0-9-_]+)+@(([\.]?)[a-zA-Z0-9-]{2,}){1,3}\.[a-zA-Z]{2,15}$/,
  // This should be improved to match an URL
  FINANCIAL_INSTITUTION_NUMBER: /^\d{3}$/,
  HTTP_URL_COMMON_CHARACTERS_REGEX: /^[a-zA-ZÀ-ÿ-_0-9.\/:&?+=%]{2,}$/,
  PHONE_NUMBER_PATTERN: /^(\+1\d{10})$/,
  POLICY_NUMBER: {
    ECONOMICAL: /^(\d{9})$/,
    GENERAL: /^([a-zA-Z]|\d|-){6,15}$/,
    INTACT: /^[a-zA-Z0-9]{3}-[a-zA-Z0-9]{4}$|^[a-zA-Z0-9]{9}$/,
    PROMUTUEL: /^[a-zA-Z]\d{10}-\d{2}$/,
    TRAVELERS: /^(\d{10})$|^APP(\d{7})$/,
    UNIQUE: /^(\d{8})$/,
    WAWANESA: /^(\d{8})$/,
  },
  POSTAL_BOXES: /^(P\.?O\.?\s+BOX|C\.?P\.?)\s+\d+(\s+(STN|SUCC)\s+[A-Z])?$/,
  POSTAL_CODE_CANADA_REGEX: /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/,
  POSTAL_CODE_QUEBEC_REGEX: /^(G|g|H|h|J|j)[0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/,
  PROPER_NOUN_REGEX: /^['a-zA-ZÀ-ÿ-_\s.]{2,}$/,
  QUOTES_ID: /^quo_(\d|[a-z]){32}$/,
  QUERY_PARAMETER: /^([A-Za-z-_0-9+%,;\.\(\)\[\]\{\}]){2,}$/,
  RECEIPT_URL:
    /^.*\?T=([A-Za-z0-9-_=]+[.][A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*)&Q=TQ[0123456789ABCDEFGH]{8}&C=[a-zA-Z0-9]{1,10}$/,
  REDIRECTION_REQUEST_ID: /^(red_([a-z0-9]){32})$/,
  REFERRAL_ID: /^ref_([a-z0-9]){32}$/,
  SHORT_DATE_REGEX: /^\d{4}-\d{2}-\d{2}$/,
  SOURCE_ID: /^(sou_([a-z0-9]){32})$/,
  UNSIGNED_INTEGER: /^\+?(0|[1-9]\d*)$/,
  UNSIGNED_INTEGER_REGEX: /^\d*$/,
  USER_ID: /^usr_([a-z0-9]){32}$/,
};

// Character regex to validate a single character
// Mainly used for input masks
export const CharacterMaskRegex = {
  ALPHANUMERIC_REGEX: /[a-zA-Z0-9]/,
  ANY_REGEX: /./,
  CAR_VIN_REGEX: /(?![iIoOqQ])[a-zA-Z0-9]/,
  COMMON_CHARACTERS_REGEX: /['a-zA-ZÀ-ÿ-_\s0-9',.\(\)/&]/,
  DIGIT_REGEX: /\d/,
  LETTER_REGEX: /[a-zA-Z]/,
  PROPER_NOUN_REGEX: /['a-zA-ZÀ-ÿ-_.\s]/,
  SPECIAL_CHARACTERS: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
};
